const resources = {
    "weautomateautomation": {}
}

export default resources;